var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[_c('video',{ref:"my-video",staticClass:"h-100 w-100 video-js vjs-default-skin",attrs:{"id":"my-video","playsinline":"","controls":"","autoplay":"","crossorigin":"anonymous"}},[_c('source',{attrs:{"src":`${_vm.videoController.file.url}`,"type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }